angular.module("multiSelect.components", [])
    .component("multiSelect", {
        templateUrl: "ng/components/multiSelect/multiSelect.view.html",
        bindings: {
            listOfElement: '<',
            listOfElementSelected: '<',
            placeholderSelect: '@',
            change: '&',
            inputClass: '@',
            name: '@',
            value: '@',
            numberOfPossibleSelection: "<",
            initialized: '<',
            withoutValue: '<',
            snapshot: '<',
            disabled: '<'
        },
        controllerAs: "multiSelectCtrl",
        controller: function ($timeout) {

            var self = this;
            self.initialized = false;

            self.$onInit = function () {
                self.variabile = "";
                self.isSelected = [];
                self.object = {};
                self.withoutValue = self.withoutValue || false;
                self.possibleSelection = self.numberOfPossibleSelection || false;
                self.tempList = [];

            }

            var init = function () {
                var listOfSelected = [];
                var numberOfSelection = self.numberOfPossibleSelection || 0;
                self.tempList = JSON.parse(JSON.stringify(self.listOfElement));
                self.listOfElement = self.listOfElement &&
                    self.listOfElement
                        .map(function (e) {
                            return {
                                name: self.withoutValue ? e[self.name] : e[self.name] + ' (' + e[self.value] + ')',
                                value: e[self.value],
                                selected: self.listOfElementSelected && self.listOfElementSelected
                                    .some(function (f) {
                                        return e[self.name] === f[self.name] && e[self.value] == f[self.value]
                                    })
                            }
                        });
                $timeout(function () {
                    jQuery('.' + self.inputClass)
                        .dropdown({
                            placeholder: self.placeholderSelect,
                            maxSelections: numberOfSelection,
                            match: 'both',
                            fullTextSearch: true,
                            allowCategorySelection: true,
                            message: {
                                addResult: 'Add <b>{term}</b>',
                                count: '{count} selezionati',
                                maxSelections: 'Massimo {maxCount} selezioni',
                                noResults: 'Nessun risultato.'
                            },
                            onRemove: function (removedValue, removedText, $removedChoice) {
                                self.isSelected = self.isSelected
                                    .filter(function (element) {
                                        return element.name != removedText;
                                    })
                                self.elementSelected();
                            },
                            onAdd: function (addedValue, addedText, $addedChoice) {
                                self.isSelected.push({
                                    name: addedText,
                                    value: addedValue,
                                    selected: true
                                });
                                self.elementSelected();
                            }
                        });
                    refresh();
                    if (self.initialized) {
                        self.elementSelected();
                    }
                }, 200)

            }



            self.$onChanges = function (changes) {

                console.log(changes);
                if (changes.listOfElement &&
                    changes.listOfElement.currentValue &&
                    changes.listOfElement.currentValue.length) {
                    self.initialized = changes.listOfElement.currentValue.length > 0;
                    init();

                }
            }


            self.elementSelected = function () {
                var selected = self.isSelected.map(function (e) {
                    return {
                        [self.name]: e.name,
                        [self.value]: e.value,
                        selected: e.selected
                    }
                })
                var listOfSelect = [];
                selected.forEach(function (s) {
                    self.tempList
                        .forEach(function (e) {

                            if (!self.withoutValue) {
                                if ((s[self.name] == e[self.name] + " (" + e[self.value] + ")")) {

                                    listOfSelect.push(e);
                                }
                            } else {
                                if ((s[self.name].trim() == e[self.name].trim())) {

                                    listOfSelect.push(e);
                                }
                            }


                        })

                })
                listOfSelect.forEach(function (element) {
                    element.selected = true;
                })

                console.log("multiSelect: ", listOfSelect);

                self.change({
                    selected: listOfSelect
                })

            }
            var refresh = function () {
                var selected = self.listOfElement.filter(function (e) {
                    return e.selected == true
                }).map(function (e) {
                    return e.value
                })
                jQuery('.' + self.inputClass)
                    .dropdown('clear');
                jQuery('.' + self.inputClass)
                    .dropdown('set selected', selected);
            }


        }
    })